import { useEffect } from 'react'
import { USE_LOCAL_STORAGE_KEY, USE_LOCAL_STORAGE_PERSIST_KEY } from 'hooks/use-local-storage'
import useGeoLocation from 'hooks/use-geo-location'
import useLanguage from 'hooks/use-language'
import useAnalyticEventTracking from 'hooks/use-analytic-event-tracking'

import AppRoutes from '../../routes'

const AppSetup = () => {
  const { watchLocation } = useGeoLocation()
  useLanguage()
  useAnalyticEventTracking()
  useEffect(() => {
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i)
      // Remove all redux persist states except the current version
      if (key && key.includes('persist') && key !== `persist:${process.env.REACT_APP_VERSION}`) {
        localStorage.removeItem(key)
      }
      // Remove all use-local-storage states except the current version
      if (key && key.includes(USE_LOCAL_STORAGE_KEY) && key !== USE_LOCAL_STORAGE_PERSIST_KEY) {
        localStorage.removeItem(key)
      }
    }

    watchLocation()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return <AppRoutes />
}

export default AppSetup
